module.exports = __webpack_public_path__ + "img/dreamroom_preview.35a2d8ce.webp";